import { FC } from 'react';
import SubTableV1 from 'src/components/commons/subTableV1';
import PageContainer from 'src/components/pageContainer/PageContainer';
import useTypeSubtable from './hooks/useTypeSubtable';

const TypesSubtable: FC = () => {
  const {
    data,
    columns,
    addNewRecord,
    editRecord,
    deleteRecord,
    autocompleteFieldSearch,
    sortRecord,
  } = useTypeSubtable();
  return (
    <PageContainer>
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <SubTableV1
          data={data ?? []}
          columns={columns ?? []}
          columnFilterShown
          total
          nonSelectable
          showAutoIncrement
          actionCell={['delete']}
          scroll={{ y: '55vh', x: 'auto' }}
          postData={addNewRecord}
          editRecord={editRecord}
          onDeleteClick={deleteRecord}
          autocompleteFieldProvider={autocompleteFieldSearch}
          onSortChange={sortRecord}
          allowGlobalEditActive
          id='types'
        />
      </div>
    </PageContainer>
  );
};

export default TypesSubtable;
